// ------------------------------------
// COMPRAS RECENTES
// ------------------------------------

initComprasRecentes();

function initComprasRecentes() {
  // Variáveis
  const $el = $('.cr-side'); // Elemento principal
  let lista = $el.data('list'); // Lista de compras
  const status = $el.data('status') == '1'; // Status ativo/inativo
  const duration = 3; // Tempo que fica visível (Segundos) / Mudar a transição do css tbm
  const intervalMin = 30; // Tempo mínimo (segundos) de intervalo entre os alertas
  const intervalMax = 50; // Tempo máximo (segundos) de intervalo entre os alertas
  const firstInterval = 10; // Tempo até o primeiro aparecer
  let timer;
  let compra;

  if (timer) {
    clearTimeout(timer);
  }

  if (typeof lista === 'string') {
    lista = JSON.parse(lista);
  }

  // Verifica se o elemento existe
  if ($el.length > 0 && status) {
    // Inicializa
    /* setTimeout(() => {
      showCompraRecente();
    }, randomNumber(intervalMin, intervalMax) * 1000); */
    setTimeout(() => {
      showCompraRecente();
    }, firstInterval * 1000);
    // Exibe uma compra recente
    function showCompraRecente() {
      if (getRandRegistro()) {
        const interval = randomNumber(intervalMin, intervalMax);
        //const interval = 10;
        //$el.find('img').attr('src', compra['img-src']).attr('alt', compra['img-alt']);
        $el.find('.cr-side-nome').text(compra.nome);
        $el.find('.cr-side-cidade').text(compra.cidade);
        $el.addClass('active');
        timer = setTimeout(() => {
          showCompraRecente();
        }, interval * 1000);
        setTimeout(() => {
          $el.removeClass('active');
        }, duration * 1000);
      } else if (timer) {
        clearTimeout(timer);
      }
    }

    // Retorna um registro aleatório
    function getRandRegistro() {
      const index = Math.floor(Math.random() * (lista.length - 1) + 0);
      if (lista[index]) {
        compra = lista[index];
        lista.splice(index, 1);
        return true;
      }
      return false;
    }
  }
}
